import type { IntegrationType } from 'src/core/hooks/useIntegrations'
import createRegistry from 'src/core/utils/createRegistry'

import { IntegrationRegistration } from './types'

const integrationRegistry = createRegistry<IntegrationRegistration<string>>()

const NO_INTEGRATION: IntegrationRegistration<string> = {
	disableWriteback: () => true,
	getExistingNote: () => Promise.resolve(null),
	onWriteback: () => Promise.resolve(console.warn('No integration registered')),
}

export const registerIntegration = <T extends string>(
	key: IntegrationType,
	registration: IntegrationRegistration<T>,
) => {
	integrationRegistry.add(key, registration)
}

export const getIntegration = (key: IntegrationType | null | undefined) => {
	if (!key) {
		return NO_INTEGRATION
	}

	return integrationRegistry.get(key) || NO_INTEGRATION
}
